module.exports = __webpack_public_path__ + "img/weatherBc1.1641520899224.jpg";